import { Injectable } from '@angular/core';
import { IBuyerViewModel, IBuyerFilterViewModel } from '../../models/accountModel';
import { DataService } from '../data.service';
import { Observable } from 'rxjs/Observable';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class BuyerService {
  moduleUrl: string;
  private retryLimit = 1;
  constructor(private _dataService: DataService, private _httpClient: HttpClient) { }

  getBuyerList(iBuyerFilterViewModel: IBuyerFilterViewModel): Observable<IBuyerViewModel []> {
    this.moduleUrl = 'Contact/GetVisionBuyers';
    return this._dataService.add(this.moduleUrl, iBuyerFilterViewModel);
  }
}



// WEBPACK FOOTER //
// ./src/app/core/services/buyer/buyer.service.ts